import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M108.101 41.8699C108.101 41.8699 80.4706 27.42 79.0706 25.66C77.6706 23.9 76.7306 1 76.7306 1H54.7206C54.7206 1 53.7806 23.9 52.3806 25.66C50.9806 27.42 23.3506 41.8699 23.3506 41.8699C23.3506 41.8699 35.6006 56.92 65.7306 56.92C95.8506 56.92 108.101 41.8699 108.101 41.8699Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.82 47.5601C118.74 43.9301 84.1801 26.75 84.1801 26.75C84.1801 26.75 79.9801 38.14 65.7301 38.14C51.4801 38.14 47.2801 26.75 47.2801 26.75C47.2801 26.75 12.7201 43.9201 9.64011 47.5601C6.56011 51.1901 2.12012 73.54 2.12012 73.54H129.35C129.33 73.54 124.89 51.2001 121.82 47.5601Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.79 30.54C39.79 30.54 46.89 44.74 65.72 44.74C84.55 44.74 91.65 30.54 91.65 30.54"
        stroke={secondaryOutline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M44.4 27.9701C44.4 27.9701 12.36 44.32 9.88998 46.8C7.40998 49.28 2 73.55 2 73.55H59.27L50.02 28.8L44.4 27.9701Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M52.3304 13.77L42.2605 26.3201L35.9805 45.48L47.3705 41.85L46.3805 45.8101C46.3805 45.8101 52.3205 48.95 53.8105 51.75C55.3005 54.55 58.7605 72.23 58.7605 72.23C58.7605 72.23 56.0205 57.2 53.9705 45.48C52.3105 36.02 51.1605 30.34 51.8205 23.85C51.8305 23.84 52.3304 14.76 52.3304 13.77Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M46.5498 46.63L51.4998 28.9601"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M11.7002 45.9701L19.1302 74.04"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M13.1904 45.9701L13.5204 47.1801"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1201 49.39L19.8301 70.4601"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="2.3 2.3"
      />
      <path
        d="M20.1309 71.5701L20.4508 72.78"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5498 73.38V66.78H49.1898V73.55"
        stroke={outline}
        fill="none"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M52.49 58.9401C53.3129 58.9401 53.98 58.273 53.98 57.4501C53.98 56.6272 53.3129 55.9601 52.49 55.9601C51.6671 55.9601 51 56.6272 51 57.4501C51 58.273 51.6671 58.9401 52.49 58.9401Z"
        fill="white"
      />
      <path
        d="M55.2996 71.65C56.1225 71.65 56.7896 70.9829 56.7896 70.16C56.7896 69.3371 56.1225 68.67 55.2996 68.67C54.4767 68.67 53.8096 69.3371 53.8096 70.16C53.8096 70.9829 54.4767 71.65 55.2996 71.65Z"
        fill="white"
      />
      <path
        d="M87.0399 27.9701C87.0399 27.9701 119.08 44.32 121.55 46.8C124.02 49.28 129.44 73.55 129.44 73.55H72.1699L81.4199 28.8L87.0399 27.9701Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M79.1194 13.77L89.1895 26.3201L95.4695 45.48L84.0794 41.85L85.0695 45.8101C85.0695 45.8101 79.1294 48.95 77.6394 51.75C76.1494 54.55 72.6895 72.23 72.6895 72.23C72.6895 72.23 75.4295 57.2 77.4795 45.48C79.1395 36.02 80.2895 30.34 79.6295 23.85C79.6095 23.84 79.1194 14.76 79.1194 13.77Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M84.8994 46.63L79.9395 28.9601"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M119.74 45.9701L112.31 74.04"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M118.251 45.9701L117.931 47.1801"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.33 49.39L111.62 70.4601"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="2.3 2.3"
      />
      <path
        d="M111.32 71.5701L110.99 72.78"
        stroke={outline}
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.06 73.38V66.78H82.4199V73.55"
        fill="none"
        stroke={outline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M76.9297 73.38L82.0497 47.29"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.722"
          y1="33.1867"
          x2="65.722"
          y2="22.8831"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
